import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sysne-alert',
  templateUrl: './sysne-alert.component.html',
  styleUrls: ['./sysne-alert.component.scss']
})
export class SysneAlertComponent {

  @Input() type: 'success' | 'warning' | 'error' | 'info' | 'neutral' = 'info';
  @Input() text: string = '';

  // 🔥 acción
  @Input() showAction: boolean = false;
  @Input() actionLabel: string = 'Aceptar';

  @Output() action = new EventEmitter<void>();

  get icon() {
    switch (this.type) {
      case 'success': return '✔';
      case 'warning': return '⚠';
      case 'error': return '✖';
      case 'info': return 'ℹ';
      default: return '•';
    }
  }

  onActionClick() {
    this.action.emit();
  }
}